import { Component } from '@angular/core';

import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Router } from '@angular/router';
import { AppService } from './services/app.service';

import { BroadcastService, MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent
{
    title = 'bienestar';
    idleState = 'Not started.';
    timedOut = false;
    lastPing?: Date = null;
    afiliado: boolean = false;
    admin: boolean = false;
    ejecutivo: boolean = false;
    rolUsuario: string;
    muestraMenu: boolean = true;
    jubilado: string = localStorage.getItem("jubilado")

    constructor(private idle: Idle, private keepalive: Keepalive, private router: Router,
                private appService: AppService, private authService: MsalService)
    {
     
        let jubilado = localStorage.getItem("jubilado")
        // sets an idle timeout of 5 seconds, for testing purposes.
        idle.setIdle(5);
        // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
        idle.setTimeout(600);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        idle.onIdleEnd.subscribe(() =>
        {
            this.idleState = 'No longer idle.'

            console.log(this.idleState);

            this.reset();
        });

        //SE EJECUTA CUANDO PASAN LOS 10 MIN DE INACTIVIDAD
        idle.onTimeout.subscribe( () =>
        {
            //this.childModal.hide();
            this.idleState = 'Timed out!';
            this.timedOut = true;

            console.log(this.idleState);

            localStorage.removeItem("logged");

            this.logout();
        });

        //SE EJECUTA LUEGO DE 5 SEG DE INACTIVIDAD Y ACTIVA LOS 10 MINUTOS POSTERIORES DE INACTIVIDAD
        idle.onIdleStart.subscribe( () =>
        {
            this.idleState = 'You\'ve gone idle!'
            console.log(this.idleState);
            //this.childModal.show();
        });

        idle.onTimeoutWarning.subscribe( (countdown) =>
        {
            this.idleState = 'You will time out in ' + countdown + ' seconds!'
            console.log(this.idleState);
        });

        // sets the ping interval to 15 seconds
        keepalive.interval(15);

        keepalive.onPing.subscribe(() => this.lastPing = new Date());

        this.appService.getUserLoggedIn().subscribe(rol =>
        {
            this.rolUsuario = rol;

            if (rol)
            {
                idle.watch()

                this.timedOut = false
            }
            else { idle.stop() }
        })
    }

    get isFuncionario() {
        return this.rolUsuario && this.rolUsuario === 'ROLE_AFILIADO';
    }

    get isEjecutivo() {
        return this.rolUsuario && this.rolUsuario === 'ROLE_EJECUTIVO';
    }

    get isEjecutivoCaip() {
        return this.rolUsuario && this.rolUsuario === 'ROLE_EJECUTIVO_CAIP';
    }

    get isAsistenteSocial() {
        return this.rolUsuario && this.rolUsuario === 'ROLE_ASISTENTE_SOCIAL';
    }

    get isContabilidad() {
        return this.rolUsuario && this.rolUsuario === 'ROLE_CONTABILIDAD';
    }

    get isEncargadoContabilidad() {
        return this.rolUsuario && this.rolUsuario === 'ROLE_ENCARGADO_CONTABILIDAD';
    }

    get isCoordinador() {
        return this.rolUsuario && this.rolUsuario === 'ROLE_COORDINADOR';
    }

    get isAdmin() {
        return this.rolUsuario && this.rolUsuario === 'ROLE_ADMINISTRADOR';
    }

    get isEncargadoRegional() {
        return this.rolUsuario && this.rolUsuario === 'ROLE_ENCARGADO_REGIONAL';
    }
    get isEncargadoRegionalContable() {
        return this.rolUsuario && this.rolUsuario === 'ROLE_ENCARGADO_REGIONAL_CONTABLE';
    }

    get isEncargadoNacional() {
        return this.rolUsuario && this.rolUsuario === 'ROLE_ENCARGADO_NACIONAL';
    }
    get isAnonymus() {
        return this.rolUsuario && this.rolUsuario === 'ROLE_ANONYMUS';
    }

    reset()
    {
        this.idle.watch();
        this.idleState = 'Started.';
        this.timedOut = false;
    }

    /*hideChildModal(): void {
      this.childModal.hide();
    }

    stay() {
      this.childModal.hide();
      this.reset();
    }*/

    logout()
    {
        this.appService.setUserLoggedIn(null);

        this.router.navigate(['']);

        localStorage.removeItem('rol');

        localStorage.removeItem('jubilado');

        this.authService.logout();
    }


    logoutJubilado()
    {
        this.appService.setUserLoggedIn(null);    

        localStorage.removeItem('rol');

        localStorage.removeItem('jubilado');

        this.router.navigate(['/login']); 
    }
}
